(function () {
  'use strict';
  function initMobileMenu() {
    var toggle = document.querySelector('[data-menu-toggle]');
    var menu = document.querySelector('[data-mobile-menu]');
    var closeEls = document.querySelectorAll('[data-menu-close]');
    var backdrop = document.querySelector('[data-menu-backdrop]');
    if (!toggle || !menu) return;
    function open() { menu.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
    function close() { menu.classList.remove('is-open'); document.body.style.overflow = ''; }
    toggle.addEventListener('click', open);
    closeEls.forEach(function (el) { el.addEventListener('click', close); });
    if (backdrop) backdrop.addEventListener('click', close);
  }
  function initHeroCarousel() {
    var carousels = document.querySelectorAll('[data-hero-carousel]');
    carousels.forEach(function (root) {
      var track = root.querySelector('[data-carousel-track]');
      var slides = root.querySelectorAll('[data-carousel-slide]');
      var dots = root.querySelectorAll('[data-carousel-dot]');
      var prev = root.querySelector('[data-carousel-prev]');
      var next = root.querySelector('[data-carousel-next]');
      if (!track || slides.length === 0) return;
      var current = 0;
      var total = slides.length;
      var autoplayDelay = parseInt(root.dataset.autoplay || '4500', 10);
      var autoplayTimer = null;
      function goTo(index) {
        current = (index + total) % total;
        track.scrollTo({ left: slides[current].offsetLeft, behavior: 'smooth' });
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i === current); });
      }
      function startAutoplay() {
        stopAutoplay();
        if (autoplayDelay > 0) {
          autoplayTimer = setInterval(function () { goTo(current + 1); }, autoplayDelay);
        }
      }
      function stopAutoplay() { if (autoplayTimer) { clearInterval(autoplayTimer); autoplayTimer = null; } }
      if (prev) prev.addEventListener('click', function () { goTo(current - 1); startAutoplay(); });
      if (next) next.addEventListener('click', function () { goTo(current + 1); startAutoplay(); });
      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () { goTo(i); startAutoplay(); });
      });
      var scrollTimer = null;
      track.addEventListener('scroll', function () {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(function () {
          var scrollLeft = track.scrollLeft;
          var slideWidth = slides[0].offsetWidth;
          var newIndex = Math.round(scrollLeft / slideWidth);
          if (newIndex !== current) {
            current = newIndex;
            dots.forEach(function (d, i) { d.classList.toggle('is-active', i === current); });
          }
        }, 100);
      });
      root.addEventListener('mouseenter', stopAutoplay);
      root.addEventListener('mouseleave', startAutoplay);
      startAutoplay();
    });
  }
  function initFaq() {
    var items = document.querySelectorAll('[data-faq-item]');
    items.forEach(function (item) {
      var btn = item.querySelector('[data-faq-question]');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');
        items.forEach(function (i) { i.classList.remove('is-open'); });
        if (!isOpen) item.classList.add('is-open');
      });
    });
  }
  function initNewsletter() {
    var COUPON_UNLOCKED_KEY = 'nutricaps_coupon_unlocked';
    var couponBox = document.querySelector('.nl-coupon');
    var lockedEl = document.querySelector('.nl-coupon__locked');
    var hintEl = document.querySelector('.nl-card__hint');
    var successEl = document.querySelector('.nl-form__success');
    var copyBtn = document.querySelector('[data-copy-coupon]');

    function unlockCoupon() {
      if (couponBox) couponBox.classList.add('nl-coupon--unlocked');
      // Remove o "Bloqueado" e mostra "Copiar cupom" no lugar
      if (lockedEl) {
        lockedEl.style.display = 'none';
        var coupon = couponBox ? couponBox.querySelector('.nl-coupon__code') : null;
        var couponCode = coupon ? coupon.textContent.trim() : 'PRIMEIRACOMPRA';
        if (!couponBox.querySelector('[data-copy-coupon]')) {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'nl-coupon__copy';
          btn.setAttribute('data-copy-coupon', '');
          btn.dataset.coupon = couponCode;
          btn.textContent = 'Copiar cupom';
          lockedEl.parentNode.insertBefore(btn, lockedEl);
          attachCopyListener(btn);
        }
      }
      // Esconde a dica "🔒 Cadastre seu e-mail..."
      if (hintEl) hintEl.style.display = 'none';
    }

    function attachCopyListener(btn) {
      btn.addEventListener('click', function () {
        var coupon = btn.dataset.coupon || 'PRIMEIRACOMPRA';
        if (navigator.clipboard) {
          navigator.clipboard.writeText(coupon).then(function () {
            var original = btn.textContent;
            btn.textContent = '✓ Copiado!';
            setTimeout(function () { btn.textContent = original; }, 2000);
          });
        }
      });
    }

    // Caso 1: cupom já estava desbloqueado em visita anterior
    try {
      if (localStorage.getItem(COUPON_UNLOCKED_KEY) === '1') {
        unlockCoupon();
      }
    } catch (e) {}

    // Caso 2: Liquid renderizou como desbloqueado (form.posted_successfully?)
    if (couponBox && couponBox.classList.contains('nl-coupon--unlocked')) {
      try { localStorage.setItem(COUPON_UNLOCKED_KEY, '1'); } catch (e) {}
    }

    // Caso 3: mensagem de sucesso apareceu mas cupom ainda travado (bug)
    if (successEl && couponBox && !couponBox.classList.contains('nl-coupon--unlocked')) {
      unlockCoupon();
      try { localStorage.setItem(COUPON_UNLOCKED_KEY, '1'); } catch (e) {}
    }

    // Caso 4: submeteu o form agora — desbloqueia imediatamente, envia em background
    var form = document.querySelector('.nl-form');
    if (form) {
      form.addEventListener('submit', function (e) {
        var emailInput = form.querySelector('input[type="email"]');
        var email = emailInput ? emailInput.value.trim() : '';
        // Valida e-mail antes
        if (!email || !/\S+@\S+\.\S+/.test(email)) {
          return; // deixa o browser mostrar a validação nativa
        }
        e.preventDefault();
        var submitBtn = form.querySelector('button[type="submit"], input[type="submit"]');
        var originalText = submitBtn ? submitBtn.textContent : '';

        // Cria iframe escondido pra receber o submit sem recarregar a página
        var iframeName = 'nl_submit_' + Date.now();
        var iframe = document.createElement('iframe');
        iframe.name = iframeName;
        iframe.style.display = 'none';
        document.body.appendChild(iframe);
        form.target = iframeName;
        // Deixa o form submeter normal, mas direcionado pro iframe oculto
        form.submit();
        // Limpa o iframe depois de uns segundos
        setTimeout(function () {
          if (iframe.parentNode) iframe.parentNode.removeChild(iframe);
          form.removeAttribute('target');
        }, 5000);

        // Desbloqueia o cupom IMEDIATAMENTE (sem esperar resposta do servidor)
        try { localStorage.setItem(COUPON_UNLOCKED_KEY, '1'); } catch (e2) {}
        unlockCoupon();

        // Cria mensagem de sucesso se ainda não existir
        if (!form.querySelector('.nl-form__success')) {
          var msg = document.createElement('div');
          msg.className = 'nl-form__success';
          msg.style.cssText = 'margin-top:0.75rem;padding:0.625rem 0.875rem;border-radius:0.5rem;background:hsl(142 50% 95%);color:hsl(142 60% 28%);font-size:0.875rem;text-align:center;';
          msg.innerHTML = '✓ Cadastro confirmado! Use o cupom abaixo.';
          form.appendChild(msg);
        }

        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.textContent = '✓ Cadastrado!';
          setTimeout(function () {
            submitBtn.disabled = false;
            submitBtn.textContent = originalText;
          }, 3000);
        }
      });
    }

    // Botão de copiar (caso já exista no DOM, no caso de desbloqueio via Liquid)
    if (copyBtn) attachCopyListener(copyBtn);
  }
  function initProductGallery() {
    var slider = document.querySelector('[data-gallery-slider]');
    if (!slider) return;
    var slides = slider.querySelectorAll('[data-gallery-slide]');
    var thumbs = document.querySelectorAll('[data-thumb]');
    var dots = document.querySelectorAll('[data-gallery-dots] .pdp__slider-dot');
    if (slides.length === 0) return;

    function setActive(index) {
      thumbs.forEach(function (t, i) {
        if (i === index) t.classList.add('is-active');
        else t.classList.remove('is-active');
      });
      dots.forEach(function (d, i) {
        if (i === index) d.classList.add('is-active');
        else d.classList.remove('is-active');
      });
    }

    // Clicar nas miniaturas → scrolla o slider pra esse índice
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var idx = parseInt(thumb.dataset.thumbIndex, 10) || 0;
        var target = slides[idx];
        if (target) {
          slider.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
        }
        setActive(idx);
      });
    });

    // Detectar qual slide está visível e atualizar thumbs/dots (com debounce)
    var scrollTimer = null;
    slider.addEventListener('scroll', function () {
      if (scrollTimer) clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        var center = slider.scrollLeft + slider.clientWidth / 2;
        var current = 0;
        slides.forEach(function (s, i) {
          if (s.offsetLeft <= center) current = i;
        });
        setActive(current);
      }, 80);
    });
  }

  function initProductForm() {
    var form = document.querySelector('.pdp__form, .product-form, [data-product-form]');
    if (!form) return;
    var variantBtns = document.querySelectorAll('[data-variant-btn]');
    var variantInput = form.querySelector('[data-variant-id]');
    var priceEl = document.querySelector('[data-current-price]');
    var priceOldEl = document.querySelector('[data-price-old]');
    var discountBadgeEl = document.querySelector('[data-discount-badge]');
    var savingsEl = document.querySelector('[data-savings]');
    var savingsAmountEl = document.querySelector('[data-savings-amount]');
    variantBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        variantBtns.forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        if (variantInput) variantInput.value = btn.dataset.variantId;
        var price = btn.dataset.price;
        var comparePrice = btn.dataset.comparePrice;
        var saved = btn.dataset.saved;
        var discount = btn.dataset.discount;
        var onSale = btn.dataset.onSale === 'true';
        if (price && priceEl) priceEl.textContent = price;
        if (priceOldEl) {
          if (onSale && comparePrice) {
            priceOldEl.textContent = comparePrice;
            priceOldEl.hidden = false;
          } else {
            priceOldEl.hidden = true;
          }
        }
        if (discountBadgeEl) {
          if (onSale && discount && discount !== '0') {
            discountBadgeEl.textContent = '-' + discount + '%';
            discountBadgeEl.hidden = false;
          } else {
            discountBadgeEl.hidden = true;
          }
        }
        if (savingsEl) {
          if (onSale && saved) {
            if (savingsAmountEl) savingsAmountEl.textContent = saved;
            savingsEl.hidden = false;
          } else {
            savingsEl.hidden = true;
          }
        }
      });
    });
  }
  function showCartToast(productTitle) {
    var toast = document.querySelector('[data-cart-toast]');
    if (!toast) return;
    var productEl = toast.querySelector('[data-cart-toast-product]');
    if (productEl) productEl.textContent = productTitle || '';
    toast.hidden = false;
    // força reflow pra animação rodar
    void toast.offsetWidth;
    toast.classList.add('is-visible');
    if (toast._hideTimer) clearTimeout(toast._hideTimer);
    toast._hideTimer = setTimeout(function () {
      toast.classList.remove('is-visible');
      setTimeout(function () { toast.hidden = true; }, 400);
    }, 3500);
  }

  function updateCartCount(count) {
    var badge = document.querySelector('[data-cart-count]');
    if (!badge) return;
    badge.textContent = count;
    if (count > 0) {
      badge.hidden = false;
      badge.classList.remove('is-bumping');
      void badge.offsetWidth;
      badge.classList.add('is-bumping');
    } else {
      badge.hidden = true;
    }
  }

  function fetchCartAndUpdate() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        return cart;
      })
      .catch(function () {});
  }

  function initCartAddInterception() {
    // Intercepta cliques em links /cart/{id}:{qty} (Comprar Agora dos cards) e
    // em forms de produto pra adicionar via AJAX, mostrar toast e atualizar contador.
    document.addEventListener('click', function (e) {
      var link = e.target.closest('a[href^="/cart/"]');
      if (!link) return;
      var href = link.getAttribute('href');
      // Match /cart/{variantId}:{qty}
      var match = href.match(/^\/cart\/(\d+):(\d+)/);
      if (!match) return;
      e.preventDefault();
      var variantId = match[1];
      var qty = parseInt(match[2], 10) || 1;
      var productTitle = link.dataset.productTitle || (link.closest('.product-card') && link.closest('.product-card').querySelector('.product-card__title') ? link.closest('.product-card').querySelector('.product-card__title').textContent.trim() : '');
      link.classList.add('is-loading');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: qty })
      })
        .then(function (r) { return r.json(); })
        .then(function (item) {
          link.classList.remove('is-loading');
          if (item && item.title) {
            showCartToast(item.product_title || item.title);
          } else {
            showCartToast(productTitle);
          }
          return fetchCartAndUpdate();
        })
        .catch(function () {
          link.classList.remove('is-loading');
          // Fallback: navega como antes
          window.location.href = href;
        });
    });

    // Intercepta o form de adicionar ao carrinho da página de produto
    var addToCartForms = document.querySelectorAll('form[action*="/cart/add"]');
    addToCartForms.forEach(function (form) {
      form.addEventListener('submit', function (e) {
        // Forms com classe skip-toast pulam toda intercepção (vão direto pro checkout)
        if (form.classList.contains('pdp__form--skip-toast')) return;
        // Detecta se o botão clicado é "Comprar Agora" ou "Adicionar ao Carrinho"
        var submitter = e.submitter;
        var isBuyNow = submitter && submitter.getAttribute('name') === 'buy-now';
        if (isBuyNow) return; // deixa o fluxo padrão pro Comprar Agora redirecionar
        e.preventDefault();
        var formData = new FormData(form);
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: formData
        })
          .then(function (r) { return r.json(); })
          .then(function (item) {
            if (item && (item.product_title || item.title)) {
              showCartToast(item.product_title || item.title);
            } else {
              showCartToast('');
            }
            return fetchCartAndUpdate();
          })
          .catch(function () {
            form.submit();
          });
      });
    });

    // Botão "Comprar Agora" dos cards (home, coleção): add silencioso ao carrinho + redireciona pra /cart (Yampi intercepta)
    var cardBuyButtons = document.querySelectorAll('[data-card-buy-now]');
    cardBuyButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        var variantId = btn.getAttribute('data-variant-id');
        if (!variantId) return;
        // Desabilita visualmente pra evitar duplo clique
        btn.disabled = true;
        var originalHTML = btn.innerHTML;
        btn.textContent = 'Aguarde...';

        var formData = new FormData();
        formData.append('id', variantId);
        formData.append('quantity', '1');

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: formData
        })
          .then(function (r) { return r.json(); })
          .then(function () {
            // Redireciona pra /cart — Yampi intercepta e leva pro checkout dela
            window.location.href = '/cart';
          })
          .catch(function () {
            // Em caso de erro, libera o botão
            btn.disabled = false;
            btn.innerHTML = originalHTML;
          });
      });
    });
  }

  function initCountdown() {
    var countdownEl = document.querySelector('[data-countdown]');
    if (!countdownEl) return;
    var hoursEl = countdownEl.querySelector('[data-countdown-hours]');
    var minutesEl = countdownEl.querySelector('[data-countdown-minutes]');
    var secondsEl = countdownEl.querySelector('[data-countdown-seconds]');
    function pad(n) { return n < 10 ? '0' + n : '' + n; }
    function tick() {
      var now = new Date();
      var endOfDay = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59, 999);
      var diff = Math.max(0, endOfDay - now);
      var hours = Math.floor(diff / 3600000);
      var minutes = Math.floor((diff % 3600000) / 60000);
      var seconds = Math.floor((diff % 60000) / 1000);
      if (hoursEl) hoursEl.textContent = pad(hours);
      if (minutesEl) minutesEl.textContent = pad(minutes);
      if (secondsEl) secondsEl.textContent = pad(seconds);
    }
    tick();
    setInterval(tick, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  function initBenefitsCarousel() {
    var grid = document.querySelector('.benefits__grid');
    if (!grid) return;
    var items = grid.querySelectorAll('.benefits__item');
    if (items.length < 2) return;

    // Só ativa o autoplay em mobile (em desktop é grid normal de 4 colunas)
    var mq = window.matchMedia('(max-width: 639px)');
    var timer = null;
    var idx = 0;
    var paused = false;

    function goTo(i) {
      idx = (i + items.length) % items.length;
      var item = items[idx];
      grid.scrollTo({ left: item.offsetLeft, behavior: 'smooth' });
    }

    function start() {
      if (!mq.matches) return stop();
      stop();
      timer = setInterval(function () {
        if (!paused) goTo(idx + 1);
      }, 7000); // 7s
    }
    function stop() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    // Pausa quando o usuário interage (toca/arrasta)
    grid.addEventListener('touchstart', function () { paused = true; });
    grid.addEventListener('touchend', function () {
      setTimeout(function () { paused = false; }, 3000);
    });

    // Atualiza idx quando user faz swipe manual
    grid.addEventListener('scroll', function () {
      var center = grid.scrollLeft + grid.clientWidth / 2;
      for (var i = 0; i < items.length; i++) {
        var item = items[i];
        if (center >= item.offsetLeft && center < item.offsetLeft + item.clientWidth) {
          idx = i; break;
        }
      }
    });

    mq.addEventListener('change', function () { start(); });
    start();
  }

  function initFullBleedCarousel() {
    // Encontra o carrossel manual e marca TODOS os ancestrais que podem estar limitando a largura
    var carousels = document.querySelectorAll('[class*="ai-carousel-"]');
    carousels.forEach(function (c) {
      var parent = c.parentElement;
      while (parent && parent !== document.body) {
        var cls = parent.className || '';
        // Marca qualquer shopify-section, container ou wrapper que esteja no caminho
        if (cls.indexOf('shopify-section') !== -1 || parent.classList.contains('container') || cls.indexOf('page-width') !== -1) {
          parent.classList.add('shopify-section--full-bleed');
        }
        parent = parent.parentElement;
      }
    });
  }

  function init() {
    initMobileMenu();
    initHeroCarousel();
    initBenefitsCarousel();
    initFullBleedCarousel();
    initFaq();
    initNewsletter();
    initProductGallery();
    initProductForm();
    initCartAddInterception();
    initCountdown();
  }
})();